// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { quickOrderSearchStyles } from "@awc/Overrides/Widgets/QuickOrder/QuickOrderSearch";
import { xScreen } from "@awc/XDL/Utilities";
import { css } from "styled-components";

quickOrderSearchStyles.productSelector = {
    container: { gap: 20 },
    searchGridItem: {
        width: [6, 6, 6, 4, 4],
        css: css`
            &&& {
                max-width: unset;
            }
            ${xScreen("lte", "sm")} {
                max-width: 100%;
                flex-basis: 100%;
            }
        `,
    },
    qtyGridItem: {
        css: css`
            &&& {
                width: auto;
            }
        `,
    },
    qtyFieldStyle: {
        wrapper: {
            css: css`
                max-width: 120px;
                width: 70%;
            `,
        },
    },
    unitOfMeasureGridItem: {
        width: 6,
        css: css`
            width: 50%;
            max-width: unset;
            ${xScreen("lte", "sm")} {
                &&& {
                    flex-grow: 1;
                }
            }
        `,
    },
    unitOfMeasureSelect: {
        cssOverrides: {
            formInputWrapper: css`
                width: 70%;
                max-width: 136px;
            `,
        },
    },
    buttonGridItem: {
        width: 12,
        css: css`
            justify-content: end;
        `,
    },
    selectButton: {
        variant: "tertiary",
    },
};
